// import React, { useState } from "react";

// import { Card, Button } from "@mui/material";

// import "../../ExamPage/ConfirmStartDialog.css"; // keep your styling if you have it

// // ────────────────────────────────────────────────────────────────

// // Standalone / Demo version of ConfirmStartDialog

// // Useful for testing the dialog independently

// // ────────────────────────────────────────────────────────────────

// const ConfirmStartDialogDemo = () => {

//     const [open, setOpen] = useState(true);

//     const [loading, setLoading] = useState(false);

//     const [fullscreenStatus, setFullscreenStatus] = useState("Not requested yet");

//     const requestFullscreen = () => {

//         const elem = document.documentElement;

//         if (elem.requestFullscreen) {

//             elem.requestFullscreen()

//                 .then(() => setFullscreenStatus("Fullscreen mode activated ✓"))

//                 .catch(err => setFullscreenStatus("Failed: " + err.message));

//         }

//         else if (elem.webkitRequestFullscreen) { // Safari

//             elem.webkitRequestFullscreen();

//             setFullscreenStatus("Safari fullscreen requested");

//         }

//         else if (elem.msRequestFullscreen) { // IE11

//             elem.msRequestFullscreen();

//             setFullscreenStatus("IE11 fullscreen requested");

//         }

//         else {

//             setFullscreenStatus("Fullscreen not supported in this browser");

//         }

//     };

//     const handleStartExam = async () => {

//         setLoading(true);

//         // Simulate some delay (like fetching exam data / initializing in real app)

//         await new Promise(resolve => setTimeout(resolve, 1400));

//         console.log("→ Exam would start now! (mock mode)");

//         alert("Exam Started! (This is demo mode)");

//         // Try to enter fullscreen

//         requestFullscreen();

//         // In real app you would do something like:

//         // navigate("/exam/portal");

//         setLoading(false);

//         // setOpen(false); // ← uncomment if you want dialog to disappear

//     };

//     const handleCancel = () => {

//         setOpen(false);

//         console.log("Start exam cancelled");

//     };

//     if (!open) {

//         return (
//             <div style={{ padding: "60px", textAlign: "center", fontFamily: "system-ui" }}>
//                 <h2>Dialog closed</h2>
//                 <Button

//                     variant="contained"

//                     color="primary"

//                     onClick={() => setOpen(true)}
//                 >

//                     Re-open Confirm Dialog
//                 </Button>
//             </div>

//         );

//     }

//     return (
//         <div

//             className="confirm-dialog-overlay"

//             style={{

//                 position: "fixed",

//                 inset: 0,

//                 backgroundColor: "rgba(0, 0, 0, 0.7)",

//                 display: "flex",

//                 alignItems: "center",

//                 justifyContent: "center",

//                 zIndex: 1500,

//             }}
//         >
//             <Card

//                 className="confirm-dialog-container"

//                 elevation={12}

//                 sx={{

//                     width: { xs: "90%", sm: 480 },

//                     borderRadius: 3,

//                     overflow: "hidden",

//                     textAlign: "center",

//                 }}
//             >
//                 <div className="confirm-dialog-header">

//                     Confirm Exam Start
//                 </div>

//                 <div className="confirm-dialog-message">

//                     You have reviewed all instructions.<br />

//                     Click <strong>Start Exam</strong> to begin your test.
//                     <div className="confirm-dialog-warning" style={{ marginTop: "16px" }}>

//                         Once started, the timer cannot be paused.
//                     </div>
//                 </div>

//                 {/* Only for demo/testing */}
//                 <div

//                     style={{

//                         padding: "0 24px 16px",

//                         color: "#666",

//                         fontSize: "0.9rem",

//                     }}
//                 >

//                     Fullscreen status: <strong>{fullscreenStatus}</strong>
//                 </div>

//                 <div className="confirm-dialog-buttons" style={{ padding: "0 24px 24px" }}>
//                     <Button

//                         variant="outlined"

//                         color="inherit"

//                         onClick={handleCancel}

//                         disabled={loading}

//                         sx={{ mr: 2, minWidth: 120 }}
//                     >

//                         Cancel
//                     </Button>

//                     <Button

//                         variant="contained"

//                         color="primary"

//                         onClick={handleStartExam}

//                         disabled={loading}

//                         sx={{ minWidth: 140 }}
//                         className="start-exam-tour-btn"
//                     >

//                         {loading ? "Starting..." : "Start Exam"}
//                     </Button>
//                 </div>
//             </Card>
//         </div>

//     );

// };

// // ────────────────────────────────────────────────────────────────

// // Original component (for reference / real usage)

// // ────────────────────────────────────────────────────────────────

// export const ConfirmStartDialog = ({ onConfirm, onCancel, loading }) => {

//     const requestFullscreen = () => {

//         const elem = document.documentElement;

//         if (elem.requestFullscreen) {

//             elem.requestFullscreen().catch(() => { });

//         } else if (elem.webkitRequestFullscreen) {

//             elem.webkitRequestFullscreen();

//         } else if (elem.msRequestFullscreen) {

//             elem.msRequestFullscreen();

//         }

//     };

//     const handleStartExam = async () => {

//         // Give parent chance to do initialization first

//         if (onConfirm) {

//             await onConfirm(); // support async parent actions

//         }

//         // Then try fullscreen

//         requestFullscreen();

//     };

//     return (
//         <div className="confirm-dialog-overlay">
//             <Card className="confirm-dialog-container">
//                 <div className="confirm-dialog-header">Confirm Exam Start</div>

//                 <div className="confirm-dialog-message">

//                     You have reviewed all instructions. <br />

//                     Click <strong>Start Exam</strong> to begin your test.
//                     <span className="confirm-dialog-warning">

//                         Once started, the timer cannot be paused.
//                     </span>
//                 </div>

//                 <div className="confirm-dialog-buttons">

//                     {onCancel && (
//                         <button

//                             className="confirm-btn cancel"

//                             onClick={onCancel}

//                             disabled={loading}
//                         >

//                             Cancel
//                         </button>

//                     )}

//                     <button

//                         className="confirm-btn start"

//                         onClick={handleStartExam}

//                         disabled={loading}
//                     >

//                         {loading ? "Starting..." : "Start Exam"}
//                     </button>
//                 </div>
//             </Card>
//         </div>

//     );

// };

// // For quick isolated testing — change export to use demo version

// export default ConfirmStartDialogDemo;







import React, { useState } from "react";
import { Card, Button } from "@mui/material";
import "../../ExamPage/ConfirmStartDialog.css";

const ConfirmStartDialog = ({ onConfirm, onCancel, loading = false }) => {
  const [fullscreenStatus, setFullscreenStatus] = useState("Not requested yet");

  const enterFullscreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen().catch(() => {});
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const handleStartExam = () => {
    // Tell parent: user wants to start
    if (onConfirm) {
      onConfirm();
    }

    // Request fullscreen (can happen after parent logic)
    enterFullscreen();
  };

  return (
    <div className="confirm-dialog-overlay">
      <Card className="confirm-dialog-container">
        <div className="confirm-dialog-header">Confirm Exam Start</div>

        <div className="confirm-dialog-message">
          You have reviewed all instructions.<br />
          Click <strong>Start Exam</strong> to begin your test.
          <span className="confirm-dialog-warning">
            Once started, the timer cannot be paused.
          </span>
        </div>

        <div className="confirm-dialog-buttons">
          <button
            className="confirm-btn cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="confirm-btn start"
            onClick={handleStartExam}
            disabled={loading}
          >
            {loading ? "Starting..." : "Start Exam"}
          </button>
        </div>
      </Card>
    </div>
  );
};

export default ConfirmStartDialog;